import React from 'react';
import InstitutionLogo from './InstitutionLogo';
import StarBorder from './StarBorder';

const Education = () => {
    const entries = [
        {
            logo: '/images/logouai.jpeg',
            logoAlt: 'Logotipo de Facultad de Ingeniería y Ciencias de la Universidad Adolfo Ibáñez',
            fallback: 'UAI',
            school: 'Facultad de Ingeniería y Ciencias de la Universidad Adolfo Ibáñez',
            datesFirst: true,
            dates: '2022 – 2026'
        },
        {
            logo: '/images/logosantiagocollege.png',
            logoAlt: 'Logotipo de Santiago College',
            fallback: 'SC',
            school: 'Santiago College',
            datesFirst: false,
            degree: 'High School Diploma',
            dates: 'mar. 2010 – dic. 2021',
            detail: null
        }
    ];

    return (
        <section id="education" className="education-section">
            <span className="section-heading__accent text-center d-block">Formación</span>
            <h2 className="section-heading">Educación</h2>
            <div className="row justify-content-center mt-4">
                <div className="col-lg-9 col-md-11 mx-auto">
                    {entries.map((edu, index) => (
                        <div key={index} className="education-item mb-3">
                            <StarBorder
                                as="div"
                                block
                                innerClassName="lg-glass lg-glass--sm education-entry education-entry--education"
                                color="rgba(126, 189, 203, 0.32)"
                                speed="12s"
                            >
                                <InstitutionLogo
                                    src={edu.logo}
                                    alt={edu.logoAlt}
                                    fallback={edu.fallback}
                                />
                                <div className="education-entry__body">
                                    <h3 className="education-entry__school">{edu.school}</h3>
                                    {edu.datesFirst ? (
                                        <p className="education-entry__dates mb-0">{edu.dates}</p>
                                    ) : (
                                        <>
                                            {edu.degree ? (
                                                <p className="education-entry__degree mb-0">{edu.degree}</p>
                                            ) : null}
                                            <p className="education-entry__dates mb-0">{edu.dates}</p>
                                            {edu.detail ? (
                                                <p className="education-entry__meta mb-0">{edu.detail}</p>
                                            ) : null}
                                        </>
                                    )}
                                </div>
                            </StarBorder>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Education;
